import React from 'react';
import './ProduccionSelector.css';
import {Row, Col, Box} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {Content} from '../ui/Content';
import {DiasInfo} from './DiasInfo';
import {NotasSection} from './NotasSection';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

export const ProduccionSelectorView = ({
  history,
  topAlert,
  produccionSelectorGet,
  datos,
  token,
  queryParams,
}) => {
  if (!datos.parametrosById) {
    return <Loader isLoading />;
  }

  return (
    <Content
      title="Reporte de producción"
      history={history}
      showBackButton={queryParams?.showBackButton === 'no' ? false : true}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}
      <Row>
        <Col xs="12" md="10" mdOffset="1">
          <Loader isLoading={produccionSelectorGet.loading}>
            <Box style={{minWidth: 700}}>
              <div style={{marginLeft: 10, marginRight: 10}}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}>
                  {datos.selectorNombre ? (
                    <div style={{fontSize: 18}}>
                      Selector: {datos.selectorNombre}
                    </div>
                  ) : null}
                  <div style={{fontSize: 18, display: 'flex'}}>
                    <div style={{minWidth: 200, flex: 2}}>
                      <div>Fecha de inicio: {queryParams.fechaInicio}</div>
                      <div>Fecha de fin: {queryParams.fechaFin}</div>
                    </div>
                    {datos.cantidadDiasSemana > 1 &&
                      queryParams.tipo === 'selectorYSupervisor' && (
                        <div style={{flex: 4}}>
                          <div>Días hábiles: {datos.cantidadDiasHabiles}</div>

                          <div>Feriados: {datos.cantidadFeriados}</div>
                        </div>
                      )}
                  </div>

                  <hr style={{width: '100%'}} />

                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="contenedor" style={{flex: 2}}>
                      <div className="cuadro">
                        <div className="titulo">Filtros: </div>
                        <div className={`numero`}>{datos.llamadas}</div>
                      </div>
                      <div className="cuadro">
                        <div className="titulo">Citados: </div>
                        <div className={`numero`}>{datos.citados}</div>
                      </div>
                      <div className="cuadro">
                        <div className="titulo">Entrevistas: </div>
                        <div className={`numero`}>{datos.entrevistas}</div>
                      </div>
                      <div className="cuadro">
                        <div className="titulo">Procesados: </div>
                        <div className={`numero`}>{datos.procesados}</div>
                      </div>
                      <div className="cuadro">
                        <div className="titulo">Cierres: </div>
                        <div className={`numero`}>{datos.cierres}</div>
                      </div>
                    </div>
                    <div className="contenedor" style={{flex: 4}}>
                      {' '}
                      <div className="cuadro" style={{marginRight: 30}}>
                        <div className="titulo titulo-largo">
                          Filtros vs. Citados:
                        </div>
                        <div className="numero">
                          {datos.llamadasVsCitados < 1 &&
                          datos.llamadasVsCitados > 0
                            ? datos.llamadasVsCitados?.toFixed(1)
                            : datos.llamadasVsCitados?.toFixed()}
                          %
                        </div>
                      </div>
                      <div className="cuadro" style={{marginRight: 30}}>
                        <div className="titulo titulo-largo">
                          Filtros vs. Procesados:
                        </div>
                        <div className="numero">
                          {datos.llamadasVsProcesados < 1 &&
                          datos.llamadasVsProcesados > 0
                            ? datos.llamadasVsProcesados?.toFixed(1)
                            : datos.llamadasVsProcesados?.toFixed()}
                          %
                        </div>
                      </div>
                      <div className="cuadro">
                        <div className="titulo titulo-largo">
                          Entrevistas vs. Procesados:
                        </div>
                        <div className="numero">
                          {datos.entrevistasVsProcesados < 1 &&
                          datos.llamadasVsProcesados > 0
                            ? datos.entrevistasVsProcesados?.toFixed(1)
                            : datos.entrevistasVsProcesados?.toFixed()}
                          %
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{display: 'flex'}}></div>

                  {datos.cantidadDiasSemana > 1 &&
                    queryParams.tipo === 'selectorYSupervisor' && (
                      <>
                        <hr style={{width: '100%', marginBottom: 5}} />
                        <DiasInfo datos={datos} />
                      </>
                    )}
                </div>
              </div>
            </Box>

            {datos.oportunidadesCierres?.length ? (
              <Box title="Cierres">
                <div className="table-responsive">
                  <DataTable
                    lazy
                    pt={{
                      table: {
                        className: 'table table-hover',
                      },
                    }}
                    value={datos.oportunidadesCierres}
                    emptyMessage="No se encontraron registros"
                    scrollHeight="150px">
                    <Column header="Oportunidad" field="titulo" />
                  </DataTable>
                </div>
              </Box>
            ) : null}
          </Loader>
        </Col>
        <Col xs="12" md="10" mdOffset="1">
          <NotasSection history={history} token={token} />
        </Col>
      </Row>
    </Content>
  );
};
